<template>
    <div class="page-wrapper">
      <div class="page-title">
        <CIcon name="cil-settings" /> Settings
      </div>
    <content-loader
        v-if="user == null"
        :width="476"
        :height="124"
        :speed="2"
        primaryColor="#8a8a8a"
        secondaryColor="#ecebeb"
    >
        <rect x="48" y="8" rx="3" ry="3" width="88" height="6" /> 
        <rect x="48" y="26" rx="3" ry="3" width="52" height="6" /> 
        <rect x="0" y="56" rx="3" ry="3" width="410" height="6" /> 
        <rect x="0" y="72" rx="3" ry="3" width="380" height="6" /> 
        <rect x="0" y="88" rx="3" ry="3" width="178" height="6" /> 
        <circle cx="20" cy="20" r="20" />
    </content-loader>
    
    <div class="" v-else>    
        <CContainer>
            <CCard>
                <CCardHeader>
                    <h4 class="card-title mb-0">Profile</h4>
                </CCardHeader>
                <CCardBody>
                    <CRow>
                        <CCol sm="12" class="text-center">
                            <div class="mb-2">
                                <span class="user-avatar-lg">{{user.name ? user.name.charAt(0).toUpperCase() : 'U'}}</span>
                            </div>
                            <h5 class="mb-1">{{user.name}}</h5>
                            <div class="text-muted">
                                {{user.email}} &bull; {{user.phone}} <br>
                                <CBadge color="primary" class="mt-1">{{roles[user.role]}}</CBadge>
                            </div>  
                        </CCol>
                    </CRow> 
                </CCardBody>
            </CCard>           
        </CContainer>
        <CContainer>
            <CCard>
                <CCardHeader>
                    <h4 class="card-title mb-0"><CIcon name="cil-laptop" /> Logged In Devices</h4>
                    <small class="text-muted">{{user.devices ? user.devices.length : 0}} active session(s)</small>
                </CCardHeader>
                <CCardBody>
                    <CRow>
                        <CCol sm="6" class="text-left">
                            <ol class="list-unstyled mb-0">
                                <li v-for="device in user.devices" v-bind:key="device.deviceId" class="mb-3 pb-2" style="border-bottom: 1px solid #f0f0f0;">
                                    <div class="d-flex align-items-center gap-2">
                                        <CIcon name="cil-laptop" class="text-muted" />
                                        <div>
                                            <strong>{{device.deviceType ? device.deviceType.toUpperCase() : 'Unknown Device'}}</strong><br>
                                            <small class="text-muted">Last seen {{device.lastSeen | moment("from")}}</small>
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </CCol>
                    </CRow> 
                </CCardBody>
            </CCard>           
        </CContainer>
    </div>
    </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';
import axios from 'axios';
import store from '../store';
export default {
    name: 'Setting',
    components: {
        ContentLoader
    },
    data() {
        return {
            baseURL : store.state.baseURL,   
            user : null,
            roles : {
                "public" : "Citizen",
                "researcher" : "Researcher",
                "watchers" : "Watchers or RRTs",
                "rfo" : "Range Forest Officer or above",
                "dfo" : "Division Forest Officer or above",
                "ccf" : "Chief Conservator of Forest or above",
                "admin" : "System Admin",
                "subadmin" : "Sub Admin",
            },     
        }
    },
    created() {
        this.getUser();
    },
    methods : {
        getUser(){
            axios({
                url : this.baseURL + "user/profile",
                headers : {
                    authorization : store.state.token
                },
                method : "GET"
            })
            .then(res => {
                if(res.data.status)
                {                    
                    this.user = res.data.data
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                
            });
        }

    }

}
</script>
